import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _ExposureLimitsListTable, _InfoSection, _InfoTabs } from "../components";
import { _Autocomplete, _DateField, _Select } from "../form";
import useTable from "../hooks/Table";

interface IRouteParam {
    ID_Anag: string;
}

export const _ExposureLimitsList: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag } = useParams<IRouteParam>();
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({
        ID_FideAffidamento: "",
        ID_Utente: "",
        ID_TipoFideAffidamento: "",
        ScadenzaAffidamento: "",
        AnagA: ID_Anag,
        ID_AnagA: ID_Anag
    });
    const { Data, Options, IsLoading } = useTable("/api/FideAffidamento/Ricerca", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideAffidamentoController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Home", ID_MenuMain: 10 });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={CreateIcon} Title="Affidamento">
                    {Glob.AzioneAbilitata("FideAffidamentoController", Glob.Scrittura) && (
                        <NavLink to={`/anagrafica/${ID_Anag}/fideaffidamento/0`}>
                            <Tooltip title={Trad.Trad("Nuovo")}>
                                <IconButton size="small" aria-label="add">
                                    <AddIcon color="action" />
                                </IconButton>
                            </Tooltip>
                        </NavLink>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <_InfoSection DataUrl={`/api/anag/Contesto?ID_Anag=${ID_Anag}`} LinkUrl={`/anagrafica/${ID_Anag}`} Title="Anagrafica" />
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <form noValidate autoComplete="off">
                                        <Grid container spacing={4}>
                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    fullWidth
                                                    id="ID_FideAffidamento"
                                                    label={Trad.Trad("ID")}
                                                    value={FormData.ID_FideAffidamento}
                                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <_Autocomplete
                                                    SearchInput
                                                    TranslationsOff
                                                    Value={FormData.ID_Utente}
                                                    Name="ID_Utente"
                                                    Label="Utente sottoscrittore"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Utenti/ListaUtenti"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_Autocomplete
                                                    SearchInput
                                                    Value={FormData.ID_TipoFideAffidamento}
                                                    Name="ID_TipoFideAffidamento"
                                                    Label="Tipo"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=FideAffidamento"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_Autocomplete
                                                    Disabled
                                                    Value={ID_Anag}
                                                    Name="ID_AnagDa"
                                                    Label="Affidato"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <_Autocomplete
                                                    Value={FormData.ID_AnagA}
                                                    Name="ID_AnagA"
                                                    Label="Sottoscrittore"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=8&ricerca="
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_DateField
                                                    Value={FormData.ScadenzaAffidamento || ""}
                                                    Name="ScadenzaAffidamento"
                                                    Label="ScadenzaAffidamento"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    required={false}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid>
                                            <Grid item md={1}>
                                                <_Button
                                                    Attivo={!IsLoading}
                                                    Testo={Trad.Trad("Cerca")}
                                                    OnClick={() => {
                                                        Options.onChangePage(0);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                    <_ExposureLimitsListTable Data={Data} IsLoading={IsLoading} Options={Options} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/ExposureLimitsList.tsx